var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`fe-w-full fe-h-xs fe-rounded-full ${_vm.backgroundColor}`},[_c('div',{staticClass:"fe-h-xs fe-rounded-full",class:_vm.filledColor,style:({ width: _vm.progress + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }